module.exports = __webpack_public_path__ + "img/wangzhezhilu.d3a6b320.jpg";